var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.showConfirmationSlot
        ? _c("div", { class: _vm.$style.container }, [
            !!(_vm.serverErrorMessage || _vm.paymentSuccessful)
              ? _c(
                  "div",
                  { class: _vm.$style.alertWrapper },
                  [
                    _c("NsAlert", {
                      class: _vm.$style.alert,
                      attrs: {
                        type: "card",
                        context: _vm.paymentSuccessful ? "success" : "error",
                        title: _vm.paymentSuccessful
                          ? _vm.successLabel
                          : _vm.errorLabel,
                        visible: ""
                      },
                      on: { dismiss: _vm.handleDismissAlert },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "body",
                            fn: function() {
                              return [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(
                                      _vm.paymentSuccessful
                                        ? _vm.successMessage
                                        : _vm.serverErrorMessage
                                    ) +
                                    "\n        "
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        3580172157
                      )
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "form",
              {
                class: _vm.$style.form,
                attrs: { "data-testid": "donation-form", novalidate: "" }
              },
              [
                _c(
                  "div",
                  { class: _vm.$style.formSection },
                  [
                    _c("h4", { class: _vm.$style.sectionTitle }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.personalInfoTitle) +
                          "\n        "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "NsTextField",
                      {
                        class: ["text-field", { error: _vm.errors.firstName }],
                        attrs: {
                          id: "first-name",
                          label: _vm.firstNameLabel,
                          type: "text",
                          required: ""
                        },
                        on: {
                          blur: function($event) {
                            return _vm.checkValidation("firstName")
                          },
                          focus: function($event) {
                            return _vm.removeErrors("firstName")
                          }
                        },
                        model: {
                          value: _vm.firstName,
                          callback: function($$v) {
                            _vm.firstName = $$v
                          },
                          expression: "firstName"
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.errors.firstName ? _vm.fieldRequiredText : ""
                            ) +
                            "\n        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "NsTextField",
                      {
                        class: ["text-field", { error: _vm.errors.lastName }],
                        attrs: {
                          id: "last-name",
                          label: _vm.lastNameLabel,
                          type: "text",
                          required: ""
                        },
                        on: {
                          blur: function($event) {
                            return _vm.checkValidation("lastName")
                          },
                          focus: function($event) {
                            return _vm.removeErrors("lastName")
                          }
                        },
                        model: {
                          value: _vm.lastName,
                          callback: function($$v) {
                            _vm.lastName = $$v
                          },
                          expression: "lastName"
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.errors.lastName ? _vm.fieldRequiredText : ""
                            ) +
                            "\n        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "NsTextField",
                      {
                        class: ["text-field", { error: _vm.errors.email }],
                        attrs: {
                          id: "email",
                          label: _vm.emailLabel,
                          type: "text",
                          required: ""
                        },
                        on: {
                          blur: function($event) {
                            return _vm.checkValidation("email")
                          },
                          focus: function($event) {
                            return _vm.removeErrors("email")
                          }
                        },
                        model: {
                          value: _vm.email,
                          callback: function($$v) {
                            _vm.email = $$v
                          },
                          expression: "email"
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.errors.email
                                ? !_vm.email
                                  ? _vm.fieldRequiredText
                                  : _vm.invalidEmailText
                                : ""
                            ) +
                            "\n        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("NsTextField", {
                      class: "text-field",
                      attrs: {
                        id: "affiliate-id",
                        label:
                          _vm.nuskinIdLabel + " (" + _vm.optionalLabel + ")",
                        type: "text"
                      },
                      model: {
                        value: _vm.distId,
                        callback: function($$v) {
                          _vm.distId = $$v
                        },
                        expression: "distId"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { class: _vm.$style.separator }),
                _vm._v(" "),
                _c(
                  "div",
                  { class: _vm.$style.formSection },
                  [
                    _c("h4", { class: _vm.$style.sectionTitle }, [
                      _vm._v(
                        "\n          " + _vm._s(_vm.amountTitle) + "\n        "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        class: _vm.$style.donationAmounts,
                        style: _vm.donationBtnsStyle
                      },
                      _vm._l(_vm.buttonAmounts, function(amt) {
                        return _c(
                          "button",
                          {
                            key: amt.value,
                            class: [
                              "btn-primary",
                              amt.value === _vm.buttonAmount
                                ? "hit-solid"
                                : "primary-outline",
                              _vm.$style.donationAmount
                            ],
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.updateAmount(amt.value)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(amt.displayText) +
                                "\n          "
                            )
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "NsCurrencyTextField",
                      {
                        class: [
                          "text-field",
                          { error: _vm.errors.donationAmount }
                        ],
                        attrs: {
                          id: "custom-amount",
                          icon: "icon-dollar",
                          label: _vm.amountLabel,
                          type: "text",
                          required: ""
                        },
                        on: {
                          blur: function($event) {
                            return _vm.checkValidation("donationAmount")
                          },
                          focus: _vm.focusCustomAmount
                        },
                        model: {
                          value: _vm.customAmount,
                          callback: function($$v) {
                            _vm.customAmount = $$v
                          },
                          expression: "customAmount"
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              +_vm.errors.donationAmount
                                ? _vm.minDonationAmountText
                                : ""
                            ) +
                            "\n        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { class: _vm.$style.sectionSpacer }),
                    _vm._v(" "),
                    _vm.showRecurringOption
                      ? [
                          _c("h4", { class: _vm.$style.sectionTitle }, [
                            _vm._v(_vm._s(_vm.donationTypeLabel))
                          ]),
                          _vm._v(" "),
                          _c("div", { class: _vm.$style.donationTypes }, [
                            _c("label", { class: _vm.$style.typeLabel }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.donationType,
                                    expression: "donationType"
                                  }
                                ],
                                attrs: {
                                  type: "radio",
                                  name: "donationType",
                                  value: "oneTime"
                                },
                                domProps: {
                                  checked: _vm._q(_vm.donationType, "oneTime")
                                },
                                on: {
                                  change: function($event) {
                                    _vm.donationType = "oneTime"
                                  }
                                }
                              }),
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.oneTimeLabel) +
                                  "\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("label", { class: _vm.$style.typeLabel }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.donationType,
                                    expression: "donationType"
                                  }
                                ],
                                attrs: {
                                  type: "radio",
                                  name: "donationType",
                                  value: "monthly"
                                },
                                domProps: {
                                  checked: _vm._q(_vm.donationType, "monthly")
                                },
                                on: {
                                  change: function($event) {
                                    _vm.donationType = "monthly"
                                  }
                                }
                              }),
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.monthlyLabel) +
                                  "\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.donationType === "monthly" &&
                                      _vm.monthlyTermsMessage,
                                    expression:
                                      "donationType === 'monthly' && monthlyTermsMessage"
                                  }
                                ],
                                class: _vm.$style.donationText
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.monthlyTermsMessage) +
                                    "\n            "
                                )
                              ]
                            )
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _c("h4", { class: _vm.$style.sectionTitle }, [
                      _vm._v(_vm._s(_vm.cardTitle))
                    ]),
                    _vm._v(" "),
                    _c("NsCreditCard", {
                      ref: "creditCardNumber",
                      attrs: {
                        "available-payments": _vm.availablePayments,
                        translations: {
                          fieldLabel: _vm.cardNumberLabel,
                          fieldRequired: _vm.fieldRequiredText,
                          notRecognizedCard: _vm.invalidCardNumberText,
                          placeholder: "    -    -    -    "
                        }
                      },
                      model: {
                        value: _vm.cardNumber,
                        callback: function($$v) {
                          _vm.cardNumber = $$v
                        },
                        expression: "cardNumber"
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { class: _vm.$style.expiryCvcRow }, [
                      _c(
                        "div",
                        { class: _vm.$style.rowItem },
                        [
                          _c("NsCreditCardDate", {
                            ref: "creditCardDate",
                            attrs: {
                              translations: {
                                label: _vm.expiryLabel,
                                monthPlaceholder: _vm.monthPlaceholderText,
                                yearPlaceholder: _vm.yearPlaceholderText,
                                fieldRequired: _vm.fieldRequiredText
                              }
                            },
                            on: {
                              "date-valid-state": function($event) {
                                _vm.validDate = $event
                              }
                            },
                            model: {
                              value: _vm.cardExpiry,
                              callback: function($$v) {
                                _vm.cardExpiry = $$v
                              },
                              expression: "cardExpiry"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { class: _vm.$style.rowItem },
                        [
                          _c(
                            "NsTextField",
                            {
                              class: [
                                "text-field",
                                { error: _vm.errors.cardCvc }
                              ],
                              attrs: {
                                id: "card-cvc",
                                label: _vm.cvcLabel,
                                type: "text",
                                required: ""
                              },
                              on: {
                                blur: function($event) {
                                  return _vm.checkValidation("cardCvc")
                                },
                                focus: function($event) {
                                  return _vm.removeErrors("cardCvc")
                                }
                              },
                              model: {
                                value: _vm.cardCvc,
                                callback: function($$v) {
                                  _vm.cardCvc = $$v
                                },
                                expression: "cardCvc"
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.errors.cardCvc
                                      ? _vm.fieldRequiredText
                                      : ""
                                  ) +
                                  "\n            "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "hit-solid fluid",
                        class:
                          ((_obj = {}),
                          (_obj[_vm.$style.buttonProcessing] = _vm.processing),
                          _obj),
                        attrs: { type: "button", diabled: _vm.processing },
                        on: { click: _vm.pay }
                      },
                      [
                        !_vm.processing
                          ? _c("span", [
                              _vm._v(
                                _vm._s(_vm.submitLabel) +
                                  _vm._s(_vm.formattedDonationAmount)
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.processing
                          ? _c("span", { class: _vm.$style.processing }, [
                              _vm._v(_vm._s(_vm.processingText)),
                              _c("span", [_vm._v(".")]),
                              _c("span", [_vm._v(".")]),
                              _c("span", [_vm._v(".")])
                            ])
                          : _vm._e()
                      ]
                    )
                  ],
                  2
                )
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showConfirmationSlot
        ? _vm._t("default", null, {
            transaction: _vm.transaction,
            handleBack: _vm.backToDonationForm
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }